// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Start of the day in ' + \$ctrl.branch.name"></sub-header>

  <start-the-day-new
    ng-if="\$ctrl.workingDay.status === 'PENDING'"
    branch="\$ctrl.branch"
    working-day="\$ctrl.workingDay"
  >
  </start-the-day-new>

  <start-the-day-progress
    ng-if="\$ctrl.workingDay.status === 'START_DAY_PROCESSING'"
    branch-id="\$ctrl.branchId">
  </start-the-day-progress>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/start-the-day/start-the-day.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;